module.exports = __webpack_public_path__ + "static/media/img_001_copy_2-560.64e835b7.webp";